module.exports = __webpack_public_path__ + "img/icon-gold30.9e53f220.png";